var exports = {
  "y": "xe7b6e3d6--66bfba--divider",
};

module.exports = exports;
